export default __webpack_public_path__ + "static/why-choose-bg-70692ea05822d06370e771d3521e2526.webp";